import { IAuthBasic } from "../types";

const AuthBasic: IAuthBasic = {
  username: "paypenndotUI01",
  password: "$2a$12$hIe5R7vuFEtiVSYf1vjKUu0ZBKtr0//M10ABnqgd8T5Qss.SE0nRO"
};

export default AuthBasic;
